import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import * as stngs from '~js/utils/settings';
import { LoadPhotoswipe } from '~js/components/load-photoswipe';
import { a11y } from '~js/components/a11y';

const options = {
  history: false,
  focus: false,
  mainClass: c.classes$A.mainClass,
  showHideOpacity: false, // we need that off to control the animation ourselves
  closeOnVerticalDrag: false,
  closeOnScroll: false,
  modal: false,
  escKey: false,
};

export class QuickViewPopup {
  constructor(container) {
    this.container = container;
    this.a11y = a11y;
    this.buttonsQuickView = this.container.querySelectorAll(s.selectors$K.buttonQuickView);
    this.buttonsShopTheLookQuickView = this.container.querySelectorAll(s.selectors$K.shopTheLookQuickViewButton);
    this.popupInitCallback = (trigger) => this.popupInit(trigger);

    this.buttonsQuickView?.forEach((button) => {
      if (!button.hasAttribute(a.attributes$t.quickButtonInit)) {
        button.addEventListener('click', (event) => this.initPhotoswipe(event));
        button.addEventListener('theme:popup:init', () => {
          button.classList.remove(c.classes$A.loading);

          if (button.hasAttribute(a.attributes$t.shopTheLookQuickView)) {
            this.popupInitCallback(button);
          }
        });
        button.setAttribute(a.attributes$t.quickButtonInit, '');
      }
    });

    this.buttonsShopTheLookQuickView?.forEach((button) => {
      button.addEventListener('click', () => {
        this.buttonsQuickView[0]?.dispatchEvent(new Event('click'));
      });
    });
  }

  popupInit(trigger) {
    // Handle active Quick View item
    const holder = this.loadPhotoswipe.pswpElement.querySelector(
      `[${a.attributes$t.hotspot}="${trigger.getAttribute(a.attributes$t.hotspot)}"]`
    );
    const quickViewItemHolders = this.loadPhotoswipe.pswpElement.querySelectorAll(s.selectors$K.quickViewItemHolder);

    holder.classList.add(c.classes$A.isActive);

    quickViewItemHolders.forEach((element) => {
      if (element !== holder) {
        element.classList.remove(c.classes$A.isActive);
      }
    });

    // Handle pointer events
    this.toggleQuickViewButtonsLoadingClasses(true);
    this.toggleQuickViewThumbsLoadingClasses(true);

    const onAnimationInEnd = (event) => {
      // Animation on open
      if (event.animationName === 'quickViewAnimateInUp') {
        requestAnimationFrame(() => {
          this.toggleQuickViewThumbsLoadingClasses(false);
        });
      }

      // Animation on close
      if (event.animationName === 'quickViewAnimateOutDown') {
        this.loadPhotoswipe.pswpElement.removeEventListener('animationend', onAnimationInEnd);
      }
    };

    this.loadPhotoswipe.pswpElement.addEventListener('animationend', onAnimationInEnd);

    this.loadPhotoswipe?.popup?.listen('destroy', () => {
      this.toggleQuickViewButtonsLoadingClasses(false);
      this.toggleQuickViewThumbsLoadingClasses(false);
    });
  }

  toggleQuickViewButtonsLoadingClasses(isLoading = true) {
    if (isLoading) {
      this.buttonsQuickView?.forEach((element) => {
        element.classList.add(c.classes$A.loading);
      });
      return;
    }

    this.buttonsQuickView?.forEach((element) => {
      element.classList.remove(c.classes$A.loading);
    });
  }

  toggleQuickViewThumbsLoadingClasses(isLoading = true) {
    this.buttonsShopTheLookThumb = this.loadPhotoswipe?.pswpElement.querySelectorAll(s.selectors$K.shopTheLookThumb);

    if (isLoading) {
      this.buttonsShopTheLookThumb?.forEach((element) => {
        element.classList.add(c.classes$A.loading);
      });
      return;
    }

    this.buttonsShopTheLookThumb?.forEach((element) => {
      element.classList.remove(c.classes$A.loading);
    });
  }

  initPhotoswipe(event) {
    event.preventDefault();

    const button = event.target.matches(s.selectors$K.buttonQuickView)
      ? event.target
      : event.target.closest(s.selectors$K.buttonQuickView);
    const isMobile = window.innerWidth < theme.sizes.small;
    let quickViewVariant = '';
    let isShopTheLookPopupTrigger = false;

    if (button.hasAttribute(a.attributes$t.shopTheLookQuickView)) {
      if (!isMobile) return;
      isShopTheLookPopupTrigger = true;
    }

    options.mainClass = c.classes$A.mainClass;
    button.classList.add(c.classes$A.loading);

    // Add class js-quick-view-from-cart to change the default Quick view animation
    if (button.closest(s.selectors$K.cartDrawer)) {
      document.body.classList.add(c.classes$A.quickViewFromCart);
    }

    // Set the trigger element before calling trapFocus
    this.a11y.state.trigger = button;

    if (button.hasAttribute(a.attributes$t.variantId)) {
      quickViewVariant = `&variant=${button.getAttribute(a.attributes$t.variantId)}`;
    }

    const productUrl = `${theme.routes.root}products/${button.getAttribute(
      a.attributes$t.handle
    )}?section_id=api-quickview${quickViewVariant}`;

    if (isShopTheLookPopupTrigger) {
      options.mainClass = c.classes$A.shopTheLookPopupClass;

      this.buttonsQuickView.forEach((element) => {
        element.classList.add(c.classes$A.loading);
      });

      const XMLS = new XMLSerializer();
      const quickViewItemsTemplate = this.container
        .querySelector(s.selectors$K.quickViewItemsTemplate)
        .content.firstElementChild.cloneNode(true);

      const itemsData = XMLS.serializeToString(quickViewItemsTemplate);

      this.loadPhotoswipeWithTemplate(itemsData, button);
    } else {
      this.loadPhotoswipeFromFetch(productUrl, button);
    }
  }

  loadPhotoswipeWithTemplate(data, button) {
    const items = [
      {
        html: data,
      },
    ];

    this.loadPhotoswipe = new LoadPhotoswipe(items, options, stngs.settings$5.templateIndex, button);
  }

  loadPhotoswipeFromFetch(url, button) {
    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const items = [
          {
            html: data,
          },
        ];

        this.loadPhotoswipe = new LoadPhotoswipe(items, options, stngs.settings$5.templateIndex, button);
      })
      .catch((error) => console.log('error: ', error));
  }
}